/* Densum — ficha de producto: galería, variante y cantidad */
(function () {
  function initProducto() {
    var root = document.querySelector('.dn-pdp');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var main = root.querySelector('#dn-pdp-main');
    var minis = root.querySelectorAll('.dn-pdp__mini');

    function show(btn) {
      if (!main || !btn) return;
      main.src = btn.dataset.full;
      main.removeAttribute('srcset');
      main.alt = btn.dataset.alt || '';
      minis.forEach(function (m) { m.classList.toggle('is-active', m === btn); });
    }
    var lista = root.querySelector('.dn-pdp__miniaturas');
    function filterColor(color, mediaId) {
      var items = root.querySelectorAll('.dn-pdp__miniaturas li');
      var any = Array.prototype.some.call(items, function (li) { return li.dataset.color === color; });
      var visibles = [];
      items.forEach(function (li) {
        var on = !any || li.dataset.color === color;
        li.hidden = !on;
        if (on) visibles.push(li.querySelector('.dn-pdp__mini'));
      });
      if (lista) lista.hidden = visibles.length < 2;
      var pick = visibles.filter(function (b) { return b.dataset.mediaId === mediaId; })[0] || visibles[0];
      show(pick);
    }
    minis.forEach(function (b) { b.addEventListener('click', function () { show(b); }); });

    root.querySelectorAll('.dn-pdp__chip input').forEach(function (r) {
      r.addEventListener('change', function () {
        var price = root.querySelector('[data-price]');
        if (price) price.textContent = r.dataset.price;
        var barPrice = document.querySelector('[data-bar-price]');
        if (barPrice) barPrice.textContent = r.dataset.price;
        var cmp = root.querySelector('[data-compare]');
        if (cmp) cmp.remove();
        var lab = root.querySelector('[data-option-label]');
        if (lab) lab.textContent = r.dataset.label;
        filterColor(r.dataset.color, r.dataset.mediaId);
        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(null, '', u);
        } catch (e) {}
      });
    });

    var bar = document.querySelector('.dn-pdp-barra');
    var row = root.querySelector('.dn-pdp__compra');
    if (bar && row) {
      var ticking = false;
      var update = function () {
        var on = row.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-on', on);
        if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      };
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      update();
    }


    // Packs del champú: la tarjeta elegida fija la cantidad y el total del botón.
    var packs = root.querySelector('[data-dn-packs]');
    if (packs) {
      var qtyInput = root.querySelector('[data-pack-qty]');
      var btnTxt = root.querySelector('[data-pack-btn-txt]');
      var btnBase = (root.querySelector('[data-pack-btn]') || {}).dataset;
      var finPack = new Date(packs.dataset.fin).getTime();
      var radios = function () { return Array.prototype.slice.call(packs.querySelectorAll('input[name="dn_pack"]')); };
      function aplicarPack(r) {
        if (!r) return;
        qtyInput.value = r.dataset.units;
        var total = r.dataset.total;
        if (btnTxt) btnTxt.textContent = btnBase.base + ' · ' + total;
        var barPrice = document.querySelector('[data-bar-price]');
        if (barPrice) barPrice.textContent = total;
        packs.querySelectorAll('.dn-pk').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
      }
      radios().forEach(function (r) { r.addEventListener('change', function () { aplicarPack(r); }); });
      function revisarFecha() {
        if (isNaN(finPack) || Date.now() < finPack) return;
        packs.querySelectorAll('.dn-pk[data-ends]').forEach(function (l) {
          var r = l.querySelector('input');
          l.hidden = true;
          if (r.checked) {
            r.checked = false;
            var otro = radios().filter(function (x) { return !x.closest('.dn-pk').hidden; });
            var pref = otro.filter(function (x) { return x.dataset.units === '2'; })[0] || otro[0];
            if (pref) { pref.checked = true; aplicarPack(pref); }
          }
        });
      }
      revisarFecha();
      setInterval(revisarFecha, 15000);
      document.addEventListener('dn:oferta-fin', revisarFecha);
      // Al volver atrás en el navegador puede quedar marcada otra tarjeta: se sincroniza.
      aplicarPack(radios().filter(function (x) { return x.checked; })[0]);
    }

    var qty = root.querySelector('.dn-pdp__cantidad input');
    if (qty) root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qty.value || '1', 10) + parseInt(b.dataset.qty, 10);
        qty.value = Math.min(20, Math.max(1, v));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProducto);
  else initProducto();
  document.addEventListener('shopify:section:load', initProducto);
})();
